import { memo } from 'react';

import { ChartLineIcon } from '@air/design-icons';

import { MainSideNavItem } from '~/components/v2/components/workspace/main-side-nav/item/MainSideNavItem';
import { useMainSideNavItemSelected } from '~/components/v2/components/workspace/main-side-nav/useMainSideNavItemSelected';
import { Routes } from '~/constants/routes';
import { useIsCreativePerformanceEnabled } from '~/hooks/useIsCreativePerformanceEnabled';
import { useCurrentWorkspacePermissionsContext } from '~/providers/CurrentWorkspacePermissionsProvider';
import { canViewCreativePerformance } from '~/utils/permissions/workspacePermissions';

export type MainSideNavItemPerformanceProps = {
  pathname: string;
};

export const MainSideNavItemPerformance = memo(({ pathname }: MainSideNavItemPerformanceProps) => {
  const { isEnabled: isCreativePerformanceEnabled } = useIsCreativePerformanceEnabled();
  const { data: workspacePermissions } = useCurrentWorkspacePermissionsContext();
  const { isSelected } = useMainSideNavItemSelected({
    isRouteSelected: pathname === Routes.creativePerformance,
  });

  if (!isCreativePerformanceEnabled || !canViewCreativePerformance(workspacePermissions)) {
    return null;
  }

  return (
    <MainSideNavItem
      href={Routes.creativePerformance}
      icon={ChartLineIcon}
      id="performance"
      isSelected={isSelected}
      label="Performance"
      sidebarInteractionType="creative_performance"
    />
  );
});

MainSideNavItemPerformance.displayName = 'MainSideNavItemPerformance';
